package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import kotlin.String
import com.jingfangpai.common.orm.mapping.DiagnosisSetting

object DiagnosisSettingApiClient :BaseServiceClient() {

	@JsName("getById")
	fun getById(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.DiagnosisSetting>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"id" to "${id?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.DiagnosisSetting> = httpClient.get {
				    url("/api/diagnosisSetting/getById?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getCurrentUserAvailable")
	fun getCurrentUserAvailable(userId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.diagnosisSetting.model.DiagnosisSettings>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"userId" to "${userId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.diagnosisSetting.model.DiagnosisSettings> = httpClient.get {
				    url("/api/diagnosisSetting/getCurrentUserAvailable?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("save")
	fun save(form:com.jingfangpai.common.orm.mapping.DiagnosisSetting, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.DiagnosisSetting>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.DiagnosisSetting> = httpClient.post {
				    url("/api/diagnosisSetting/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.DiagnosisSetting.serializer(),form), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
